(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/collapsible-group/assets/javascripts/collapsible-buttons-group.js') >= 0) return;  svs.modules.push('/components/tipsen/collapsible-group/assets/javascripts/collapsible-buttons-group.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _React = React,
  useState = _React.useState,
  useRef = _React.useRef,
  useEffect = _React.useEffect,
  useMemo = _React.useMemo,
  useCallback = _React.useCallback;
const _svs$components$lbUti = svs.components.lbUtils.reactConditionals,
  If = _svs$components$lbUti.If,
  Choose = _svs$components$lbUti.Choose,
  When = _svs$components$lbUti.When,
  Otherwise = _svs$components$lbUti.Otherwise,
  ForEach = _svs$components$lbUti.ForEach;
const CollapsibleButton = svs.components.tipsen.collapsibleGroup.CollapsibleButton;
const CollapsibleButtonGroup = _ref => {
  var _buttonGroupGridEleme, _buttonGroupGridEleme2;
  let setValue = _ref.setValue,
    value = _ref.value,
    allValues = _ref.allValues,
    title = _ref.title,
    _ref$promotedValues = _ref.promotedValues,
    promotedValues = _ref$promotedValues === void 0 ? [] : _ref$promotedValues,
    _ref$collapsedSize = _ref.collapsedSize,
    collapsedSize = _ref$collapsedSize === void 0 ? 9 : _ref$collapsedSize,
    _ref$gap = _ref.gap,
    gap = _ref$gap === void 0 ? 6 : _ref$gap,
    _ref$minWidth = _ref.minWidth,
    minWidth = _ref$minWidth === void 0 ? 85 : _ref$minWidth,
    _ref$render = _ref.render,
    render = _ref$render === void 0 ? v => v : _ref$render,
    _ref$clickCallback = _ref.clickCallback,
    clickCallback = _ref$clickCallback === void 0 ? () => {} : _ref$clickCallback,
    _ref$isValueDisabled = _ref.isValueDisabled,
    isValueDisabled = _ref$isValueDisabled === void 0 ? () => false : _ref$isValueDisabled;
  const buttonGroupGridElement = useRef();
  const _useState = useState(allValues.indexOf(value)),
    _useState2 = _slicedToArray(_useState, 2),
    collapsedIndex = _useState2[0],
    setCollapsedIndex = _useState2[1];
  const _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    showAllValues = _useState4[0],
    setShowAllValues = _useState4[1];
  const _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    visibleValues = _useState6[0],
    setVisibleValues = _useState6[1];
  const specialValues = useMemo(() => promotedValues ? promotedValues.filter(el => allValues.includes(el)) : [], [promotedValues, allValues]);
  const lowCount = useMemo(() => {
    const _lowCount = specialValues.length;
    return _lowCount > 0 ? _lowCount : collapsedSize;
  }, [specialValues.length, collapsedSize]);
  const useNrOfColumns = useCallback(gridWidth => Math.floor((gridWidth + gap) / (minWidth + gap)), [gap, minWidth]);
  const handleOnClick = useCallback(v => {
    setValue(v);
    clickCallback(v);
  }, [setValue, clickCallback]);
  const onToggleShowAllSystems = useCallback(() => {
    setShowAllValues(previousState => !previousState);
    setCollapsedIndex(allValues.indexOf(value));
  }, [allValues, value]);
  const hasSystemsToShow = visibleValues && visibleValues.length > 0;
  const isCollapsible = hasSystemsToShow && allValues.length > lowCount;
  const selectedIndex = hasSystemsToShow ? visibleValues.indexOf(value) : 0;
  const gridWidth = (_buttonGroupGridEleme = buttonGroupGridElement === null || buttonGroupGridElement === void 0 || (_buttonGroupGridEleme2 = buttonGroupGridElement.current) === null || _buttonGroupGridEleme2 === void 0 ? void 0 : _buttonGroupGridEleme2.clientWidth) !== null && _buttonGroupGridEleme !== void 0 ? _buttonGroupGridEleme : 0;
  const nrOfColumns = useNrOfColumns(gridWidth);
  useEffect(() => {
    if (allValues.length < lowCount) {
      setShowAllValues(true);
    }
  }, [allValues.length, setShowAllValues, lowCount]);
  useEffect(() => {
    if (showAllValues) {
      setVisibleValues(allValues);
    } else if (specialValues.includes(allValues[collapsedIndex])) {
      setVisibleValues(specialValues);
    } else {
      const displayCount = lowCount;
      const displayShift = Math.ceil(displayCount / 2) + Math.floor(nrOfColumns / 2) - collapsedIndex % nrOfColumns; 
      let minIndex = Math.max(collapsedIndex + displayShift - displayCount, 0);
      const maxIndex = Math.min(minIndex + displayCount, allValues.length);
      if (maxIndex - minIndex < displayCount) {
        minIndex = Math.max(maxIndex - displayCount, 0);
      }
      setVisibleValues(allValues.slice(minIndex, maxIndex));
    }
  }, [collapsedIndex, allValues, showAllValues, nrOfColumns, specialValues, lowCount]);
  return React.createElement("div", {
    className: "pg_collapsible_selector_container",
    ref: buttonGroupGridElement,
    role: "radiogroup"
  }, React.createElement(If, {
    condition: title && title.length > 0
  }, React.createElement("div", {
    className: "pg_collapsible_selector_container__header f-550"
  }, title)), React.createElement(Choose, null, React.createElement(When, {
    condition: hasSystemsToShow
  }, React.createElement("div", {
    className: "pg_collapsible_selector_container__grid"
  }, React.createElement(ForEach, {
    array: visibleValues,
    render: (value, index) => {
      const isDisabled = isValueDisabled(value);
      return React.createElement(CollapsibleButton, {
        isDisabled: isDisabled,
        isSelected: !isDisabled && index === selectedIndex,
        key: value,
        onClick: handleOnClick,
        value: value
      }, render(value));
    }
  })), React.createElement(If, {
    condition: isCollapsible
  }, React.createElement("div", {
    className: "pg_collapsible_selector_container__more_buttons"
  }, React.createElement(CollapsibleButton, {
    onClick: onToggleShowAllSystems,
    size: 300,
    value: "collapsible"
  }, React.createElement(Choose, null, React.createElement(When, {
    condition: showAllValues
  }, React.createElement("span", null, "Visa f\xE4rre -")), React.createElement(Otherwise, null, React.createElement("span", null, "Visa fler +"))))))), React.createElement(Otherwise, null, React.createElement("p", null, "Saknar v\xE4rden..."))));
};
setGlobal('svs.components.tipsen.collapsibleGroup.CollapsibleButtonGroup', CollapsibleButtonGroup);

 })(window);